// extracted by mini-css-extract-plugin
export var boxItems = "_8b-1";
export var button = "_8b-5";
export var filterGroupBox = "_8b-0";
export var icon = "_8b-2";
export var iconSecondary = "_8b-4";
export var iconWrapper = "_8b-3";